export default "__VITE_ASSET__C$nc$Yza__"